module.exports = __webpack_public_path__ + "static/media/bg-croatia.87adec73.jpg";